module.exports = __webpack_public_path__ + "public/images/icon-vk.dfd93903d81f795f27d210aa497f6840.svg";